
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CurrencyPipe, DecimalPipe, NgFor } from '@angular/common';
import { DestinationListType01Component } from '../../destination-list/destination-list-type01/destination-list-type01.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseCardComponent } from '@fuse/components/card';
import { Meta, Title } from '@angular/platform-browser';
import { BannerSectionType01Component } from '../../banner-section/banner_section-type01/banner_section-type01.component';

@Component({
    selector: 'black-friday-specials',
    standalone: true,
    imports: [
        MatIconModule,
        DecimalPipe,
        CurrencyPipe,
        DestinationListType01Component,
        MatTooltipModule,
        RouterLink,
        FuseCardComponent,
        BannerSectionType01Component,
        NgFor,
    ],
    templateUrl: './black-friday-specials.component.html',
    styleUrl: './black-friday-specials.component.scss',
})
export class BlackFridaySpecialsComponent implements OnInit {
    public view: any = {
        searchQuery: '',
        filteredBundles: [],
        destination: {},
        packageImageUrl:
            'https://www.shutterstock.com/image-vector/black-friday-super-sale-realistic-260nw-1842227329.jpg',
    };
    regions: string[] = [
        'Botswana',
        'Cape Town',
        'Cruising',
        'Durban',
        'Maldives',
        'Mauritius',
        'Thailand',
        'Victoria Falls',
        'Zanzibar',
    ];

    constructor(
        public tfmService: TFMService,
        private route: ActivatedRoute,
        private title: Title,
        private metaService: Meta
    ) {}

    getAdditionalContent() {
        if (
            this.view.type == 'destination-deals' ||
            this.view.type == 'experience-deals' ||
            this.view.type == 'article'
        ) {
            //Get packages for this destination
            this.tfmService
                .filterBundles(
                    {
                        rateType: 'pps',
                        onlyActive: true,
                        contentId: this.view.id,
                    },
                    false
                )
                .then((res) => {
                    this.view.bundles = res.content;
                    this.tfmService.log(this.view);
                });
        }
    }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.view.id = params['id'];
            this.tfmService.log('destination id', this.view.id);

            this.tfmService.getDestinations().then((destinations) => {
                //Check destinations are returning and assign
                this.view.destinations = destinations;

                if (
                    this.view.destinations.filter(
                        (d) => d.id && String(d.id) === String(this.view.id)
                    ).length > 0
                ) {
                    this.view.destination = this.view.destinations.filter(
                        (d) => d.id && String(d.id) === String(this.view.id)
                    )[0];

                    this.tfmService.log(
                        'Filtered destinationsArray:',
                        this.view.destination
                    );
                    if (this.view.destination.metaData) {
                        this.view.destination.metaDataParsed = JSON.parse(
                            this.view.destination.metaData
                        );
                    }
                }
            });

            this.tfmService
                .filterBundles(
                    {
                        rateType: 'pps',
                        onlyActive: true,
                        contentId: this.view.id,
                    },
                    false
                )
                .then((res) => {
                    this.view.bundles = res.content;
                    this.view.backfridaySpecials = this.view.bundles.filter(
                        (bundle) => {
                            // Check only for the Black Friday tag
                            return bundle.tags?.includes('Black Friday');
                        }
                    );
                    this.view.filteredBundles = this.view.backfridaySpecials;
                    console.log(
                        'Black friday specials',
                        this.view.backfridaySpecials
                    );
                    // this.view.filteredBundles = res.content;
                    // this.tfmService.log(this.view);
                });
        });
        this.title.setTitle(`Exclusive Travel Packages`);
        this.metaService.updateTag({
            name: 'description',
            content:
                'Unlock incredible Black Friday travel deals with XL Travel! Enjoy huge discounts on adventure trips, family getaways, romantic honeymoons, and all-inclusive packages. Make your dream journey a reality this Black Friday!',
        });
        this.metaService.updateTag({
            name: 'keywords',
            content:
                'Black Friday travel deals, holiday specials, discounted vacation packages, adventure trips, family holidays, honeymoon packages, all-inclusive Black Friday deals, travel discounts',
        });

        // this.view.filteredBundles = this.view.bundles;
        this.view.filteredBundles = this.view.backfridaySpecials;

        this.tfmService.getContentBySection('black-friday').then((res) => {
            this.view.page = res;
            console.log(this.view.page);
            if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
                const image = this.view.page?.content?.images[0]; // Access the first image object
                const links = image._links; // Access the _links array

                // Find the link with rel "view"
                const viewLink = links.find((link: any) => link.rel === "view");

                // Get the href if the view link exists
                if (viewLink) {
                this.view.imageHref = viewLink.href;
                this.tfmService.log("Image href:", this.view.imageHref);
                } else {
                console.error("View link not found");
                }
            } else {
                console.error("Images not available");
            }
        });
    }
    onSearchQueryChange(event: any) {
        this.view.searchQuery = event.target.value.toLowerCase();
        this.filterCards();
    }

    filterCards() {
        if (this.view.searchQuery) {
            this.view.filteredBundles = this.view.backfridaySpecials.filter(
                (bundle) =>
                    (bundle.destinationName || bundle.destination)
                        .toLowerCase()
                        .includes(this.view.searchQuery)
            );
        } else {
            // Show all bundles if search query is empty
            this.view.filteredBundles = this.view.backfridaySpecials;
        }
    }
    filterDestinations(): void {
        const { selectedRegions, searchQuery, backfridaySpecial } = this.view;

        this.view.filteredBundles = this.view.backfridaySpecials.filter(
            (bundle) => {
                const matchesRegion = this.view.selectedRegion
                    ? bundle.destination
                          .toLowerCase()
                          .includes(this.view.selectedRegion.toLowerCase()) ||
                      bundle.name
                          .toLowerCase()
                          .includes(this.view.selectedRegion.toLowerCase())
                    : true;

                const matchesSearchQuery = searchQuery
                    ? bundle.name.toLowerCase().includes(searchQuery) ||
                      bundle.destination.toLowerCase().includes(searchQuery)
                    : true;
                // console.log(this.view.filteredBundles);
                return matchesRegion && matchesSearchQuery;
            }
        );
    }

    onRegionSelect(region: string) {
        // if (this.view.selectedRegions.includes(region)) {
        // this.view.selectedRegions = this.view.selectedRegions.filter((r) => r !== region);
        // } else {
        // this.view.selectedRegions.push(region);
        // }
        this.view.selectedRegion = region;
        this.filterDestinations();
    }
    slugify(text: string): string {
      return text
        .toLowerCase()
        .trim()
        .replace(/[\s\W-|]+/g, '-'); // Replace spaces and non-word characters with a hyphen
    }
}
